"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _FirebaseStorageUtil = _interopRequireDefault(require("@/views/mixin/FirebaseStorageUtil"));

var _auth = require("../../utils/auth");

var _validate = require("@/utils/validate");

var _title_widget = _interopRequireDefault(require("@/views/widgets/title_widget.vue"));

var _button_widget = _interopRequireDefault(require("@/views/widgets/button_widget.vue"));

var _constants = require("@/utils/constants");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    TitleWidget: _title_widget.default,
    Button: _button_widget.default
  },
  mixins: [_FirebaseStorageUtil.default],
  data: function data() {
    var _this = this;

    var validateSurvey = function validateSurvey(rule, value, callback) {
      if (_this.surveyInputFormVisitable) {
        if (_this.form.survey.question) {
          callback();
        } else {
          callback(new Error(rule.colname + 'を入力してください。'));
        }
      } else callback();
    };

    var validateMaxLength = function validateMaxLength(rule, value, callback) {
      if (value.trim() === '' || value === null) {
        callback(new Error(rule.colname + 'を入力してください。'));
      } else if (value.length > rule.maxLen) {
        callback(new Error(rule.colname + 'は' + rule.maxLen + '桁の数値を入力してください。'));
      } else {
        callback();
      }
    };

    var validateFiles = function validateFiles(rule, value, callback) {
      if (_this.handleErrorFile()) {
        callback(new Error(rule.colname + _this.form.error));
      } else {
        callback();
      }
    };

    var validateSelectBox = function validateSelectBox(rule, value, callback) {
      if (_this.form.categoryId) {
        callback();
      } else {
        callback(new Error('選択してください'));
      }
    };

    return {
      loading_delete: false,
      role: {},
      disabledPublishAt: false,
      draftMode: false,
      surveyInputFormVisitable: false,
      buttonStatusUpdate: {
        disableUpdateButton: true
      },
      form: {
        title: '',
        publish_at: '',
        old_publish_at: '',
        content: '',
        push_notification: true,
        fileList: [],
        error: '',
        categoryId: null,
        userCreated: '',
        survey: {
          choice_type: 0,
          question: '',
          is_public_result: false,
          questions: [{
            content: '',
            errorSurvey: ''
          }, {
            content: '',
            errorSurvey: ''
          }]
        },
        originalSurvey: null
      },
      rules: {
        title: [{
          required: true,
          validator: validateMaxLength,
          colname: 'タイトル',
          maxLen: 40
        }],
        content: [{
          required: true,
          validator: validateMaxLength,
          colname: '内容',
          maxLen: 1000
        }],
        question: [{
          required: true,
          validator: validateSurvey,
          colname: '質問'
        }],
        fileList: [{
          required: false,
          validator: validateFiles,
          colname: 'ファイル'
        }],
        categoryId: [{
          required: true,
          validator: validateSelectBox,
          colname: 'カテゴリー'
        }]
      },
      addDialogVisible: false,
      waitDialogVisible: false,
      cancelSurveyDialogVisible: false,
      validateMaxLength: function validateMaxLength(rule, value, callback) {
        if (value.trim() === '' || value === null) {
          callback(new Error(rule.colname + 'を入力してください。'));
        } else if (value.length > rule.maxLen) {
          callback(new Error(rule.colname + 'は' + rule.maxLen + '桁の数値を入力してください。'));
        } else {
          callback();
        }
      },
      validateFiles: function validateFiles(rule, value, callback) {
        if (_this.handleErrorFile()) {
          callback(new Error(rule.colname + _this.form.error));
        } else {
          callback();
        }
      },
      validateSelectBox: function validateSelectBox(rule, value, callback) {
        if (_this.form.categoryId) {
          callback();
        } else {
          callback(new Error('選択してください'));
        }
      },
      validateSurvey: function validateSurvey(rule, value, callback) {
        if (_this.surveyInputFormVisitable) {
          if (_this.form.survey.question) {
            callback();
          } else {
            callback(new Error(rule.colname + 'を入力してください。'));
          }
        } else callback();
      }
    };
  },
  watch: {
    $data: {
      deep: true,
      handler: function handler(value) {
        this.listeningStatusUpdateButton(value);
      }
    }
  },
  computed: {
    hasEditPermission: function hasEditPermission() {
      return this.role.admin_bulletin_edit;
    },
    bulletinCategories: function bulletinCategories() {
      return this.$store.getters.bulletinCategories;
    },
    bulletinById: function bulletinById() {
      return this.$store.getters.bulletinById;
    },
    situation: function situation() {
      return this.$store.getters.situation;
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var _this2 = this;

      var survey_id, roleType, questions;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.$store.commit('bulletin/setOptionValue', 1);
              _context.next = 3;
              return this.$store.dispatch('bulletin/getBulletinCategories');

            case 3:
              survey_id = this.$route.params.surveyId;

              if (!survey_id) {
                _context.next = 7;
                break;
              }

              _context.next = 7;
              return (0, _auth.setIdEditPage)(survey_id);

            case 7:
              _context.next = 9;
              return (0, _auth.getUserPermission)();

            case 9:
              roleType = _context.sent;

              if (roleType) {
                this.role = JSON.parse(roleType);
              }

              _context.next = 13;
              return this.$store.dispatch('bulletin/getBulletinById');

            case 13:
              if (this.bulletinById) {
                this.form.id = this.bulletinById.id;
                this.form.title = this.bulletinById.title;
                this.form.content = this.bulletinById.content;
                this.form.push_notification = this.bulletinById.push_notification;
                this.form.id = this.bulletinById.id;
                this.form.publish_at = this.bulletinById.publish_at;
                this.form.old_publish_at = this.bulletinById.publish_at;

                if (this.bulletinById.publish_at) {
                  this.form.publish_at = 'now()';
                  this.disabledPublishAt = true;
                }

                this.form.categoryId = this.bulletinById.category_id;

                if (this.bulletinById.attach_files.length !== 0 && this.bulletinById.attach_files) {
                  this.bulletinById.attach_files.forEach(function (item) {
                    item.name = item.file_name, item.nameSave = item.file_name, item.restore = true;

                    _this2.form.fileList.push(item);
                  });
                }

                if (this.bulletinById.bulletin_surveys) {
                  if (this.bulletinById.bulletin_surveys.length !== 0) {
                    this.surveyInputFormVisitable = true;

                    if (this.bulletinById.bulletin_surveys[0].survey) {
                      this.form.originalSurvey = this.bulletinById.bulletin_surveys[0].survey;

                      if (this.bulletinById.bulletin_surveys[0].survey.length !== 0) {
                        this.form.survey.id = this.bulletinById.bulletin_surveys[0].survey.id;
                        this.form.survey.choice_type = this.bulletinById.bulletin_surveys[0].survey.choice_type;
                        this.form.survey.question = this.bulletinById.bulletin_surveys[0].survey.question;
                        this.form.survey.is_public_result = this.bulletinById.bulletin_surveys[0].survey.is_public_result;

                        if (this.bulletinById.bulletin_surveys[0].survey.survey_answers) {
                          if (this.bulletinById.bulletin_surveys[0].survey.survey_answers.length !== 0) {
                            this.form.survey.questions = this.bulletinById.bulletin_surveys[0].survey.survey_answers;
                          }
                        }
                      }
                    }
                  }

                  this.draftMode = this.form.publish_at === null || this.form.publish_at === '';
                }

                if (this.bulletinById.user) {
                  this.form.userCreated = this.bulletinById.user.last_name + ' ' + this.bulletinById.user.name;
                }
              }

              questions = this.form.survey.questions || [];
              (0, _auth.setHistoryDataFromPage)(JSON.stringify("".concat(this.form.title).concat(this.form.content).concat(this.form.push_notification).concat(this.form.fileList.length).concat(this.form.categoryId).concat(this.form.publish_at, "-").concat(this.form.survey.choice_type, "-").concat(this.form.survey.is_public_result, "-").concat(questions.length, "-").concat(questions.map(function (item) {
                return item.content;
              }))));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    createSurvey: function createSurvey() {
      if (!this.draftMode) {
        return;
      }

      this.resetSurvey();
      this.surveyInputFormVisitable = true;
    },
    goToIndex: function goToIndex() {
      this.$router.replace({
        name: 'BulletinIndex'
      });
    },
    listeningStatusUpdateButton: function () {
      var _listeningStatusUpdateButton = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(value) {
        var isHistory, questions, isChanged;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isHistory = (0, _auth.getHistoryDataFromPage)();
                questions = this.form.survey.questions || [];
                isChanged = JSON.stringify("".concat(value.form.title).concat(value.form.content).concat(value.form.push_notification).concat(value.form.fileList.length).concat(this.form.categoryId).concat(this.form.publish_at, "-").concat(this.form.survey.choice_type, "-").concat(this.form.survey.is_public_result, "-").concat(questions.length, "-").concat(questions.map(function (item) {
                  return item.content;
                })));
                if (isHistory !== isChanged) this.buttonStatusUpdate.disableUpdateButton = false;else this.buttonStatusUpdate.disableUpdateButton = true;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function listeningStatusUpdateButton(_x) {
        return _listeningStatusUpdateButton.apply(this, arguments);
      }

      return listeningStatusUpdateButton;
    }(),
    handleDeleteSurvey: function () {
      var _handleDeleteSurvey = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _constants.message_box_confirm)('確認', 'このアンケートを削除します。\nよろしいですか？', '削除', 'message_delete');

              case 2:
                result = _context3.sent;

                if (result) {
                  this.form.survey = {};
                  this.surveyInputFormVisitable = false;
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleDeleteSurvey() {
        return _handleDeleteSurvey.apply(this, arguments);
      }

      return handleDeleteSurvey;
    }(),
    handleDeleteItem: function () {
      var _handleDeleteItem = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var _this3 = this;

        var result, survey_id, survey_answer_id, survey, deleteItem;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _constants.message_box_confirm)('確認', 'この掲示を削除します。よろしいですか？', '削除', 'message_delete');

              case 2:
                result = _context4.sent;

                if (!result) {
                  _context4.next = 14;
                  break;
                }

                this.loading_delete = true;
                survey_id = [];
                survey_answer_id = [];

                if (this.bulletinById.bulletin_surveys) {
                  if (this.bulletinById.bulletin_surveys.length !== 0) {
                    if (this.bulletinById.bulletin_surveys[0].survey) {
                      if (this.bulletinById.bulletin_surveys[0].survey !== null) {
                        survey_id.push(this.bulletinById.bulletin_surveys[0].survey.id);

                        if (this.bulletinById.bulletin_surveys[0].survey.survey_answers) {
                          if (this.bulletinById.bulletin_surveys[0].survey.survey_answers.length !== 0) {
                            this.bulletinById.bulletin_surveys[0].survey.survey_answers.map(function (item) {
                              return survey_answer_id.push(item.id);
                            });
                          }
                        }
                      }
                    }
                  }
                }

                survey = {
                  bulletinId: this.bulletinById.id,
                  survey_id: survey_id,
                  survey_answer_id: survey_answer_id
                };
                _context4.next = 11;
                return this.$store.dispatch('bulletin/updateBulletinAndDeleteSurveyById', survey).catch(function (error) {
                  console.log(error);

                  _this3.$notify({
                    title: 'エラー',
                    message: '掲示の削除に失敗しました。',
                    type: 'error',
                    duration: 10000,
                    showClose: true
                  });
                });

              case 11:
                deleteItem = _context4.sent;

                if (deleteItem) {
                  this.$notify({
                    title: '情報',
                    message: '掲示の削除が完了しました。',
                    type: 'success',
                    duration: 2000
                  });
                  this.$router.replace({
                    name: 'BulletinIndex'
                  });
                }

                this.loading_delete = false;

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleDeleteItem() {
        return _handleDeleteItem.apply(this, arguments);
      }

      return handleDeleteItem;
    }(),
    bytesToSize: function bytesToSize(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return 'n/a';
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
      if (i === 0) return "".concat(bytes, " ").concat(sizes[i], ")");
      return "".concat((bytes / Math.pow(1024, i)).toFixed(1), " ").concat(sizes[i]);
    },
    messageError: function messageError(text) {
      return this.$message({
        showClose: true,
        message: text,
        duration: 8000,
        type: 'error'
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      this.form.fileList.splice(this.form.fileList.indexOf(file), 1);
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning('アップロードできるファイルは5つまでです');
    },
    handleErrorFile: function handleErrorFile(hidden) {
      var _this4 = this;

      function bytesToMegaBytes(bytes) {
        return (bytes / (1024 * 1024)).toFixed(2);
      } /// hiddenがtrueの場合、ファイルを追加するときに日付を確認します


      if (hidden) {
        this.$refs['upload'].validate(function (value) {
          return false;
        });
      }

      if (this.form.fileList) {
        if (this.form.fileList.some(function (item) {
          return bytesToMegaBytes(item.size) > 20;
        })) {
          this.form.error = '20MB以下のファイルのみを添付する可能です。';
          return true;
        }

        var hasSome = false;
        this.form.fileList.forEach(function (item, index) {
          if (item.nameSave) {
            if (_this4.form.fileList.some(function (some) {
              return some.nameSave === item.nameSave && some.uid !== item.uid;
            })) {
              _this4.form.fileList.splice(index, 1);

              hasSome = true;
            }
          }
        });
        this.form.error = '既に添付されているファイルです。';
        if (hasSome) return true;
      }
    },
    handleChange: function handleChange(file, fileList) {
      var _this5 = this;

      fileList.forEach(function (item, index) {
        if (!item.replace && (item.url === null || item.url === '' || item.url === undefined)) {
          item.nameSave = item.name;
          item.name = item.name + ' ' + "(".concat(_this5.bytesToSize(item.size), ")");
        }

        item.replace = true;
      });
      this.form.fileList = fileList;
      this.handleErrorFile(true);
    },
    validateSurveyQuestion: function validateSurveyQuestion() {
      console.log('validateSurveyQuestion', JSON.stringify(this.form.survey.questions));

      if (!this.surveyInputFormVisitable) {
        return false;
      }

      this.form.survey.questions = this.form.survey.questions.map(function (item) {
        if (item.content === '' || item.content === null) {
          item.errorSurvey = '選択肢を入力してください。';
        } else item.errorSurvey = '';

        return item;
      });
      return this.form.survey.questions.some(function (item) {
        return item.errorSurvey !== '';
      });
    },
    postFromCheck: function postFromCheck() {
      var _this6 = this;

      // エラーが発生した場合は停止します
      this.$refs['form'].validate(
      /*#__PURE__*/
      function () {
        var _ref = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee5(valid) {
          var questionText, questionYesOrNo;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (!_this6.validateSurveyQuestion()) {
                    _context5.next = 4;
                    break;
                  }

                  return _context5.abrupt("return", false);

                case 4:
                  if (!valid) {
                    _context5.next = 13;
                    break;
                  }

                  questionText = 'この掲示をアプリへ公開します。よろしいですか？';

                  if (!_this6.form.publish_at || _this6.form.old_publish_at) {
                    questionText = '掲示を更新します。よろしいですか？';
                  }

                  _context5.next = 9;
                  return (0, _constants.message_box_confirm)('確認', questionText, '更新', 'message_default');

                case 9:
                  questionYesOrNo = _context5.sent;

                  if (questionYesOrNo) {
                    _this6.onUpdate();
                  }

                  _context5.next = 15;
                  break;

                case 13:
                  _this6.log('error submit!!');

                  return _context5.abrupt("return", false);

                case 15:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    onUpdate: function () {
      var _onUpdate = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee6() {
        var _this7 = this;

        var index, zoneId, file_name_extract, path, fileURL, saveBulletin, success_message;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.waitDialogVisible = true;
                this.addDialogVisible = false;

                if (!(this.form.fileList.length !== 0)) {
                  _context6.next = 22;
                  break;
                }

                index = 0;

              case 4:
                if (!(index < this.form.fileList.length)) {
                  _context6.next = 22;
                  break;
                }

                if (!(this.form.fileList[index].url === null || this.form.fileList[index].url === '' || this.form.fileList[index].url === undefined)) {
                  _context6.next = 19;
                  break;
                }

                _context6.next = 8;
                return (0, _auth.getZoneId)();

              case 8:
                zoneId = _context6.sent;
                file_name_extract = (0, _validate.extractExtAndNameFromFilename)(this.form.fileList[index].nameSave);
                path = "bulletins/".concat(zoneId, "/").concat(file_name_extract.nameFile, "-").concat((0, _v.default)(), ".").concat(file_name_extract.extension);
                _context6.next = 13;
                return this.uploadFileToStorage(this.form.fileList[index].raw, path);

              case 13:
                fileURL = _context6.sent;

                if (!(fileURL === null)) {
                  _context6.next = 18;
                  break;
                }

                console.log('ファイルのアップロードに失敗しました。');
                this.waitDialogVisible = false;
                return _context6.abrupt("return");

              case 18:
                this.form.fileList[index].url = fileURL;

              case 19:
                index++;
                _context6.next = 4;
                break;

              case 22:
                _context6.next = 24;
                return this.$store.dispatch('bulletin/updateBulletin', this.form).catch(function (error) {
                  _this7.waitDialogVisible = false;

                  _this7.$notify({
                    title: 'エラー',
                    message: '更新に失敗しました。',
                    type: 'error',
                    duration: 10000,
                    showClose: true
                  });

                  console.log(error);
                  throw error;
                });

              case 24:
                saveBulletin = _context6.sent;

                if (saveBulletin) {
                  this.waitDialogVisible = false;
                  success_message = '掲示を公開しました';

                  if (this.form.old_publish_at || !this.form.publish_at) {
                    success_message = '更新しました。';
                  }

                  this.$notify({
                    title: '情報',
                    message: success_message,
                    type: 'success',
                    duration: 2000
                  });
                  this.$router.replace({
                    name: 'BulletinIndex'
                  });
                }

              case 26:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function onUpdate() {
        return _onUpdate.apply(this, arguments);
      }

      return onUpdate;
    }(),
    addSelection: function addSelection() {
      this.form.survey.questions.push({
        content: '',
        errorSurvey: ''
      });
    },
    deleteSelection: function deleteSelection(index) {
      this.form.survey.questions.splice(index, 1);
    },
    resetSurvey: function resetSurvey() {
      this.form.survey = {
        choice_type: 0,
        question: '',
        is_public_result: false,
        questions: [{
          content: '',
          errorSurvey: ''
        }, {
          content: '',
          errorSurvey: ''
        }]
      };
    }
  }
};
exports.default = _default;